module.exports = __webpack_public_path__ + "img/hyal-2@2x.af222396.png";